<div *ngIf="isManualEntry" class="manual-entry-warning-container">
  <div class="flex grid-gap-10">
    <div class="flex-shrink-1 manual-entry-warning-icon">
      <i class="fa fa-info-circle" style="color: #012169"></i>
    </div>
    <div class="flex-grow-1">
      Please click <strong>‘Confirm Changes’</strong> to save the changes to your address
    </div>
  </div>
</div>
